import { COMING_SOON_KEY } from "@/lib/brand"
import { lumi } from "@/lib/lumi"
import type { SiteSetting } from "@/types"

export async function loadComingSoonSetting(): Promise<SiteSetting | null> {
  const res = await lumi.entities.site_settings.list({
    filter: { key: COMING_SOON_KEY },
    limit: 5,
  })
  const rows = ((res?.list || []) as SiteSetting[]).filter((item) => item.key === COMING_SOON_KEY)
  return rows[0] || null
}

export function isComingSoonEnabled(setting: SiteSetting | null): boolean {
  if (!setting) return true
  return setting.enabled !== false
}
